import { Component, Output, EventEmitter, ViewChild, Input } from '@angular/core';

import { ActionModalComponent } from '../action-modal/action-modal.component';
import { ActionModalButton } from '../action-modal/action-modal.interface';

@Component({
    selector: 'mapp-delete-modal',
    templateUrl: './delete-modal.component.html',
    standalone: false,
})
export class DeleteModalComponent<T> {
    @Input() data: T;

    @Output() buttonFunction: EventEmitter<void | T> = new EventEmitter();

    @ViewChild(ActionModalComponent) modal!: ActionModalComponent;

    protected primaryButtonObject: ActionModalButton = {
        label: 'Delete',
        action: () => this.handlePrimaryButtonClick(),
    };

    protected secondaryButtonObject: ActionModalButton = {
        label: 'Cancel',
        action: () => this.close(),
    };

    /**
     *
     */
    open(): void {
        this.modal.open();
    }

    /**
     *
     */
    close(): void {
        this.modal.close();
    }

    /**
     *
     */
    handlePrimaryButtonClick() {
        this.close();
        this.buttonFunction.emit(this.data || undefined);
    }
}
